module.exports = __webpack_public_path__ + "img/qinghua.81c212f0.jpg";